import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/invoices")({
  head: () => ({ meta: [{ title: "Invoices | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-invoices")),
});
